import { render, staticRenderFns } from "./MessageItemTimelineDemo.vue?vue&type=template&id=1c496ed2&scoped=true"
import script from "./MessageItemTimelineDemo.vue?vue&type=script&lang=js"
export * from "./MessageItemTimelineDemo.vue?vue&type=script&lang=js"
import style0 from "./MessageItemTimelineDemo.vue?vue&type=style&index=0&id=1c496ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c496ed2",
  null
  
)

export default component.exports